import React from "react";
import { useHistory, Link } from "react-router-dom";
import { useSelector } from 'react-redux'
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { snake2Pascal } from "utils/text";
import {
  AppBar,
  Toolbar,
  IconButton,
  Container,
  Hidden,
} from "@material-ui/core";
import logoImage from 'assets/images/navicon.png'

import MenuIcon from "@material-ui/icons/Menu";
import Logo from "./Logo";
// import MainMenu from "./MainMenu";
// import QuickMenu from "./QuickMenu";
import MyAccountMenu from "./MyAccountMenu";

export default function PrimarySearchAppBar({
  isOpenedDrawer,
  handleDrawerOpen,
}) {
  const classes = useStyles();
  const myUser = useSelector(state => state.auth.user)
  const history = useHistory();
  const { pathname } = history.location;
  const mainMenuPath = pathname.split("/")[1];

  return (
    <div className={classes.grow}>
      <AppBar position="static" elevation={0} className={classes.root}>
        <Container maxWidth="lg" className={classes.container}>
          <Hidden mdUp>
            <Toolbar className={classes.toolbar}>
              <IconButton
                color="#000000"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                className={clsx(
                  classes.menuButton,
                  isOpenedDrawer && classes.hide
                )}
              >
                <MenuIcon />
              </IconButton>
              <Hidden smUp>
                <Logo />
              </Hidden>

              <div className={`${classes.drawerHeader} custom-d-header`}>
                <img src={logoImage}
                  className={classes.logoImage}
                  alt={'ZWAGIL Foundation'}
                />
              </div>
              <h2 className={`${classes.menuTitle} custom-d-header-title`}>{snake2Pascal(mainMenuPath)}</h2>
              <MyAccountMenu />
            </Toolbar>
          </Hidden>
        </Container>
      </AppBar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
  grow: {
    flexGrow: 1,
  },
  root: {
    backgroundColor: "#ffffff",
  },
  toolbar: {
    paddingTop: theme.spacing(1.2),
    minHeight: 60,
    paddingLeft: 0,
    paddingRight: 0,
  },
  hide: {
    display: "none",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "center",
    
    "@media (max-width: 599px)": {
      contentVisibility: 'hidden'
    },
  },
  logoImage: {
    maxHeight: '50px'
  },
  menuTitle: {
    fontSize: 24,
    // lineHeight: "1.5em",,
    fontWeight: "400",
    marginRight: 12,
    borderLeft: '2px solid #000',
    paddingLeft: '10px',
    color: '#000',
    
    "@media (max-width: 599px)": {
      contentVisibility: 'hidden'
    },
  },
}));
